export interface ISidebarMenuNode {
	id?: string | number;
	text?: string;
	path?: string | null;
	icon?: string;
	sectionLabel?: string;
	subMenu?: Record<string, ISidebarMenuNode> | null;
}

export interface ISidebarSection {
	key: string;
	label: string;
	permission_keys: string[];
}

export const applySidebarSections = (
	menu: Record<string, ISidebarMenuNode>,
	sections: ISidebarSection[],
): Record<string, ISidebarMenuNode> => {
	const source: Record<string, ISidebarMenuNode> = { ...menu };
	delete source.settings;

	const validSections = sections.filter(
		(section) =>
			section &&
			typeof section.label === 'string' &&
			section.label.trim() &&
			Array.isArray(section.permission_keys) &&
			section.permission_keys.length > 0,
	);
	if (!validSections.length) return source;

	const sectionByKey = new Map<string, ISidebarSection>();
	validSections.forEach((section) => {
		section.permission_keys.forEach((key) => {
			if (!source[key] || sectionByKey.has(key)) return;
			sectionByKey.set(key, section);
		});
	});

	const next: Record<string, ISidebarMenuNode> = {};
	Object.keys(source).forEach((key) => {
		const section = sectionByKey.get(key);
		const firstKey = section?.permission_keys.find((permissionKey) => source[permissionKey]);
		if (section && firstKey === key) {
			const titleId = `sidebar-title-${section.key}`;
			next[titleId] = {
				id: titleId,
				text: section.label,
				sectionLabel: section.label,
			};
		}
		next[key] = section ? { ...source[key], sectionLabel: section.label } : source[key];
	});

	return next;
};
